<template>
  <div id="pers-tab12" name="hres31x-tab12" class="content-pers" :class="{'-fixed-height-box' : pcDisp}">
    <template v-for="(value, index) in detail.tableAssetData.rows">
      <detail-template
        :index="index"
        :labels="labels"
        :detail="detail"
        inline-template>
        <div>
          <div slot="head" class="sub-topic-box color-skin" @click="toggleDisp()">
            <i class="fa fa-archive icon-sub-topic" aria-hidden="true"></i>
            <div class="sub-topic">{{ labels['HRES31XC12']['10'] }} ( {{ labels['HRES31XC11']['20'] }}  {{ index + 1 }} )</div>
          </div>

          <div slot="body" class="data-pers-box" v-show="topicDisp">
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC12']['20'] }}</div>
              <div class="col-xs-6 data-text">{{ value.numcolla }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC12']['30'] }}</div>
              <div class="col-xs-6 data-text">{{ value.descolla }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC12']['40'] }}</div>
              <div class="col-xs-6 data-text">{{ value.amtcolla }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC12']['50'] }}</div>
              <div class="col-xs-6 data-text">{{ value.numdocum }}</div>
            </div>
          </div>
        </div>
      </detail-template>
    </template>
  </div>
</template>

<script>
import detailTemplate from 'components/hres31x/detailTemplate'

export default {
  name: 'hres31x-tab12',
  components: {
    detailTemplate
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'togglePage', 'triggerButton' ]
}
</script>



// WEBPACK FOOTER //
// tab12.vue?3962cfbe